export default {
      id: "ar_cni_passeport-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ar_cni_passeport-usage",
      toString: function () {
        return this.url;
      }
    }